define('core/frameBus',[
    'jquery',
    'underscore',
    'backbone',

    'core/utils/urls',
], function (
    $,
    _,
    Backbone,

    urls
) {
    'use strict';

    // If this is a popup window, the parent window is window.opener
    // If this is an iframe, the parent window is window.parent
    var channel = window.opener || window.parent;
    // The opener/parent uses window.name/iframe name property  to pass the id
    // of the app into this window.
    // It cannot be changed by the parent after the page has loaded if they are
    // on different domains. It should not be changed in this window but can be
    // changed right after this point since it will be cached in `senderId`.
    var senderId = window.name;
    var referrer = window.document.referrer;

    // TODO: Cannot rely on referrer
    var origins = {};
    origins.client = urls.getOrigin(window.document.location.href);
    origins.secureClient = origins.client.replace(/^\w+:\/\//, 'https://');
    origins.host = referrer ? urls.getOrigin(referrer) : origins.client;

    var FrameBus = {
        origins: origins,

        messageHandler: function (event) {
            // jQuery wraps the originalEvent and puts it in, yes, originalEvent
            event = event.originalEvent;

            var message;
            try {
                message = JSON.parse(event.data);
            } catch (err) {
                // Message was not parsable - bail out
                // NOTE: We discovered that some sites were sending random,
                // unparsable messages to our iframe that were causing
                // exceptions here.
                return;
            }

            // A "!" in the beginning of an event name means it is a "Disqus-only"
            // event, such as "!audiencesync:grant" or "!auth:success". We reject
            // any event in this category that comes from a different origin. The
            // only exception is the `https` version of the client's origin such as
            // `https://disqus.com` sending a message to `http://disqus.com`.
            if (message.name && message.name[0] === '!' &&
                event.origin !== origins.client &&
                event.origin !== origins.secureClient
            )
                return;

            // Only listens to client-scoped messages
            if (message.scope !== 'client')
                return;

            FrameBus.trigger(message.name, message.data);
        },

        postMessage: function (message) {
            // NOTE: Target origin is wildcard (*), which means any JavaScript code
            //       (i.e. publishers) with a reference to the target window can listen
            //       and receive these messages. Assume that any messages sent this way
            //       can and will be readable by third-parties, and do not send any
            //       private session-identifying data.
            message = JSON.stringify(message);
            channel.postMessage(message, '*');
        },

        // Sends a message strictly to this frame's host object
        sendHostMessage: function (name, params) {
            params = params || [];

            FrameBus.postMessage({
                scope: 'host',
                sender: senderId,
                name: name,
                data: params,
            });
        },
    };
    _.extend(FrameBus, Backbone.Events);

    $(window).on('message', FrameBus.messageHandler);
    $(window).on('unload', function () { FrameBus.sendHostMessage('die'); });

    // Expose Bus on DISQUS global since some pages rely on it
    // (ex. login-success)
    window.DISQUS = window.DISQUS || {};
    window.DISQUS.Bus = FrameBus;

    return FrameBus;
});

